export const cellSizeMap = {
	small: 48,
	medium: 56,
	large: 64,
	xl: 80,
	xxl: 88,
	xxxl: 96,
};

export const headerSizeMap = {
	small: 40,
	medium: 48,
};
